import BasePage from '../../components/base-page/base-page';

import '../../main.scss';

class TryFreePage extends BasePage {
  onInit() {
    super.onInit();

    // Open signup modal automatically when page loads
    this.openSignupModal();
  }

  openSignupModal() {
    this.signupModal.open({ ...this.signupModalOptions, useHistoryBack: true, eventLabel: 'Header' });
  }
}

export default TryFreePage;

TryFreePage.initOnDomLoaded();

